import React from "react";

export default function StatCard({ label, value, sub, mono = false, accent = false, testid }) {
  return (
    <div
      data-testid={testid}
      className={`p-5 sm:p-6 border border-border bg-card transition-colors hover:border-foreground/30 rounded-sm flex flex-col gap-2 ${
        accent ? "bg-foreground text-background" : ""
      }`}
    >
      <div className={`text-[10px] sm:text-xs uppercase tracking-[0.2em] ${accent ? "opacity-60" : "text-muted-foreground"}`}>
        {label}
      </div>
      <div className={`${mono ? "font-mono" : ""} text-2xl sm:text-3xl tracking-tight font-medium`}>
        {value}
      </div>
      {sub && (
        <div className={`text-xs ${accent ? "opacity-60" : "text-muted-foreground"}`}>{sub}</div>
      )}
    </div>
  );
}
